'use client';
import { jsx } from 'react/jsx-runtime';
import { useMemo, Fragment } from 'react';
import { isNonNullish } from '../../../core/utilities/is.utils.js';
import { getSameKeyValueMapForManifest, manifestResolve } from '../../../core/utilities/manifest.utils.js';
import { useSwanHeadConfig } from './head.hook.js';
import { MANIFEST_STYLES } from '../../../core/manifest/styles.js';
import { SwanAssetFolders } from '../../../core/types/enums.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
const SWAN_STYLE_KEY_MAP = getSameKeyValueMapForManifest(MANIFEST_STYLES);
let S = [
    SWAN_STYLE_KEY_MAP.core,
    SWAN_STYLE_KEY_MAP.utility,
    ...Object.keys(MANIFEST_STYLES).filter((e)=>e !== SWAN_STYLE_KEY_MAP.core && e !== SWAN_STYLE_KEY_MAP.utility)
];
const SWAN_STYLE_KEY_LIST = S;
function getSwanStylesheetUrl(e, t, r) {
    return manifestResolve(MANIFEST_STYLES, e, SwanAssetFolders.STYLES, t, r);
}
const SwanStylesheets = ({ styleSheetKeys: o = SWAN_STYLE_KEY_LIST, swanPathType: n, swanBaseUrl: _, swanTenant: l, swanLocale: S, renderWith: s = Fragment })=>{
    let { swanBaseUrl: a, swanPathType: f } = useSwanHeadConfig(_, n, l, S), p = useMemo(()=>{
        let e = new Set(o);
        e.delete(SWAN_STYLE_KEY_MAP.core), e.delete(SWAN_STYLE_KEY_MAP.utility);
        let t = Array.from(e);
        return t.sort(), t.unshift(SWAN_STYLE_KEY_MAP.core, SWAN_STYLE_KEY_MAP.utility), t.map((e)=>getSwanStylesheetUrl(e, f, a)).filter(isNonNullish);
    }, [
        o,
        f,
        a
    ]), u = null == s || s === Fragment ? {
        precedence: 'swan-3'
    } : {};
    return jsx(s, {
        children: p.map((t)=>jsx("link", _object_spread({
                rel: "stylesheet",
                href: t
            }, u), t))
    });
};

export { SWAN_STYLE_KEY_LIST, SWAN_STYLE_KEY_MAP, SwanStylesheets, getSwanStylesheetUrl };
